import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { AUTH_FROM_KEY } from './GoogleSignIn';

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
    const from = sessionStorage.getItem(AUTH_FROM_KEY) || '/dashboard';
    sessionStorage.removeItem(AUTH_FROM_KEY);
    axios.post('/auth/google', { session_id: sessionId })
      .then(({ data }) => {
        loginWithToken(data.access_token, data.user);
        navigate(data.user.profile_incomplete ? '/complete-profile' : from, { replace: true, state: { from: { pathname: from } } });
      })
      .catch((e) => setError(e.response?.data?.detail || 'Google sign-in failed. Please try again.'));
  }, [location.hash, loginWithToken, navigate]);

  if (!error) return null;
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="google-auth-error">
      <div className="max-w-sm text-center">
        <p className="text-slate-800 font-semibold">{error}</p>
        <button type="button" onClick={() => navigate('/login', { replace: true })} className="mt-4 text-sm font-semibold text-orange-600 hover:underline" data-testid="google-auth-back">Back to sign in</button>
      </div>
    </div>
  );
};
